import React, { useRef, useState } from 'react';
import GridPhotosWrapper from './styles';
import PreviewImage from '../PreviewImage';
import { getImageUrl, isImage } from 'utils/tools';
import { Carousel, Modal } from 'antd';

interface IGridPhotos {
  images: string[];
  width: number;
  height?: number;
  maxPreview?: number;
  className?: string;
}

const GridPhotos = ({
  images,
  width,
  height,
  maxPreview = 1,
  className,
}: IGridPhotos) => {
  const carouselRef = useRef(null);
  const subImages = images ? [...images].splice(0, maxPreview) : [];
  const [previewVisible, setPreviewVisible] = useState(null);

  const handleCancel = () => {
    setPreviewVisible(null);
  };

  const onPreviewUI = (index) => {
    setPreviewVisible(true);
    setTimeout(() => {
      carouselRef.current && carouselRef.current.goTo(index);
    }, 10);
  };

  return (
    <GridPhotosWrapper width={width} height={height}>
      {subImages
        .slice(0, maxPreview >= images?.length ? maxPreview : maxPreview - 1)
        .map((data, index) => (
          <PreviewImage
            onPreview={() => onPreviewUI(index)}
            key={String(index)}
            // src={getImageUrl(data)}
            src={data}
            className={`imageCount ${className}`}
          />
        ))}
      {images && images.length - subImages.length > 0 ? (
        <div className="imageCount">
          {isImage(subImages[subImages.length - 1]) ? (
            <img
              alt=""
              src={getImageUrl(subImages[subImages.length - 1])}
              className="image"
            />
          ) : (
            <video
              src={getImageUrl(subImages[subImages.length - 1])}
              controls
            />
          )}
          {images.length - subImages.length !== 0 && (
            <div
              role="presentation"
              onClick={() => onPreviewUI(subImages.length - 1)}
              className="overlay2"
            >
              {`+${images.length - subImages.length}`}
            </div>
          )}
        </div>
      ) : null}

      <Modal open={previewVisible} footer={null} onCancel={handleCancel}>
        <Carousel arrows draggable ref={carouselRef}>
          {images &&
            images.map((data, index) => (
              <div key={String(index)}>
                {isImage(data) ? (
                  <img
                    alt="example"
                    src={getImageUrl(data, 800)}
                    style={{ width: '100%', height: '100%' }}
                  />
                ) : (
                  <video
                    src={getImageUrl(data)}
                    controls
                    className="w-full h-full"
                  />
                )}
              </div>
            ))}
        </Carousel>
      </Modal>
    </GridPhotosWrapper>
  );
};

export default GridPhotos;
